export type BuildConfiguration = 'development' | 'production' | 'staging' | 'test';
export default class AppVersion {
  public readonly buildConfiguration: BuildConfiguration = process.env!.VUE_APP_BUILD_CONFIGURATION as BuildConfiguration;
  public readonly version = process.env!.VUE_APP_VERSION;
  public readonly name = process.env!.VUE_APP_NAME;

  constructor() {
    if (this.name === undefined || this.version === undefined) {
      return;
    }

    let title = '';
    let subtitle = '';
    let backgroundColor = '#5e7fb5';
    let style = '';

    if (this.buildConfiguration === 'staging') {
      backgroundColor = '#915eb5';
    } else if (this.buildConfiguration === 'production') {
      backgroundColor = '#47b35b';
    }

    style = `
        background: ${backgroundColor};
        padding: 2px 0px;
        color: white;
    `;
    title = this.name;
    subtitle = `${this.version} - ${this.buildConfiguration}`;
    // Pad message with spaces so every line is the same size
    if (title.length < subtitle.length) {
      const padAmount = Math.floor((subtitle.length - title.length) / 2);
      title = title.padStart(padAmount + title.length, ' ');
      title = title.padEnd(subtitle.length, ' ');
    } else {
      const padAmount = Math.floor((title.length - subtitle.length) / 2);
      subtitle = subtitle.padStart(padAmount + subtitle.length, ' ');
      subtitle = subtitle.padEnd(title.length, ' ');
    }
    // Add some general padding
    const padding = 15;
    title = title.padStart(title.length + padding, ' ');
    title = title.padEnd(title.length + padding, ' ');
    subtitle = subtitle.padStart(subtitle.length + padding, ' ');
    subtitle = subtitle.padEnd(subtitle.length + padding, ' ');

    const isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
    if (isIE11) {
      // The only place where console.log is okay
      // eslint-disable-next-line no-console
      console.log(`${title}\n${subtitle}`);
    } else {
      // The only place where console.log is okay
      // eslint-disable-next-line no-console
      console.log(`%c${title}\n${subtitle}`, style);
    }
  }
}
